import { Branch, createSocketService, GDKError, Lang, ErrorCode } from '@golden/gdk-base';
import { pairwise } from 'rxjs';
var payloadType;
(function (payloadType) {
    payloadType["ME"] = "agent.me";
    payloadType["ANNOUNCEMENT"] = "agent.announcements";
    payloadType["STAFF_ANNOUNCEMENT"] = "agent.staffAnnouncements";
    payloadType["AGENT_USER_STATUS"] = "agent.statistics";
})(payloadType || (payloadType = {}));
const branch = {
    'agent.me': Branch.ME,
    'agent.announcements': Branch.ANNOUNCEMENT,
    'agent.statistics': Branch.AGENT_USER_STATUS,
    'agent.staffAnnouncements': Branch.STAFF_ANNOUNCEMENT,
    'me.info': Branch.AGENT_INFO
};
export function createAgentSocketService(api, socket, trunk, agent, auth, realTime) {
    const socketService = createSocketService('agent/', api, socket, 'v2');
    socket.on('connect', () => {
        socketService.join('agents');
        realTime.updatePollingTime({
            minuteDenominator: 3,
            secondDenominator: 0
        });
    });
    socket.on('disconnect', () => {
        realTime.updatePollingTime({
            minuteDenominator: 0,
            secondDenominator: 30
        });
    });
    socket.on('not.loginable', () => {
        api.base.errors.next(new GDKError(null, Lang.ZH_CN, ErrorCode.UNAUTHENTICATED, null));
    });
    socket.on('global.data.changed', () => {
        trunk.next([Branch.PLATFORMS]);
    });
    socket.on('agent.data.changed', (payload) => {
        const nextTrunks = payload.map(item => branch[item]);
        trunk.next(nextTrunks, (error, branches) => socketService.handleError?.(error, branches));
    });
    socket.on('domain.updated', () => {
        if (!agent.me.value)
            return;
        agent.me.next({
            ...agent.me.value,
            is_domain_read: !agent.me.value.is_domain_read
        });
    });
    agent.me.pipe(pairwise()).subscribe(([prev, current]) => {
        if (!prev?.account && current?.account) {
            console.log('account changed:', current.account);
            socketService.getToken(`agents.${current.account}`).subscribe(({ token }) => {
                socketService.join(`private-agents.${current.account}`, token);
            });
        }
        if (prev?.account && !current?.account) {
            socketService.leave(`private-agents.${prev.account}`);
        }
    });
    return socketService;
}
//# sourceMappingURL=SocketService.js.map